<template>
<CCol col="12" md="12" lg="10" class="mx-auto px-0">
    <CCard>
        <div class="comming-soon" v-if="item.comming_soon"></div>
        <div class="item-lock" v-else-if="item.lock"></div>
        <CCardBody class="row">
            <div class="col-12 col-lg-10 col-sm-9">
                <CLink :disabled="item.lock" :to="item.to" class="text-decoration-none text-" :class="'text-'+item.color">
                    <h3>
                        {{ item.title }}
                        <span class="badge font-xs mfe-2" :class="'badge-'+item.color">{{ item.level }}</span>
                        <span v-if="item.lock" class="font-sm text-danger">
                            <FaIcon icon="lock" />
                        </span>
                        <span v-if="item.comming_soon" class="badge badge-dark font-xs">به زودی</span>
                    </h3>
                </CLink>
                <p v-html="item.description"></p>

            </div>
            <!-- TODO: must be completed -->
            <!-- <div class="col-12 col-lg-2 col-sm-3 bg-gray-100 d-block p-4 text-center text-dark m-auto">
                <span class="font-3xl d-block font-weight-bold" :class="'text-'+item.color">{{ item.stat.number }}</span>
                <span class="font-weight-light font-xs mt-2 d-block">{{ item.stat.description }}</span>
            </div> -->
        </CCardBody>
        <p v-if="item.lock" class="alert alert-warning mb-0">
            برای فعال‌سازی این بخش با پشتیبانی تماس بگیرید
        </p>
    </CCard>
</CCol>
</template>

<script>
export default {
    name: 'ItemBox',

    props: {
        item: {
            required: true,
            type: Object,
        }
    }
}
</script>

<style lang="scss" scoped>
.comming-soon {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background-color: gray;
    opacity: .4;
}
.item-lock {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background-color: lightgrey;
    opacity: .4;
}
</style>